import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, formatApiError } from "../../lib/api";
import { PanelTitle } from "./ui";

export const ProfilePanel = ({ profile, onSaved }) => {
  const [wallet, setWallet] = useState(profile.wallet || "");
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState("");
  const [walletError, setWalletError] = useState("");

  const saveWallet = async (e) => {
    e.preventDefault();
    setSaving("wallet");
    setWalletError("");
    try {
      await api.patch("/me/profile", { wallet: wallet.trim() });
      toast.success("Wallet guardada");
      onSaved();
    } catch (err) {
      setWalletError(formatApiError(err));
      toast.error(formatApiError(err));
    } finally {
      setSaving("");
    }
  };

  const savePassword = async (e) => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm) return toast.error("Las contraseñas nuevas no coinciden");
    setSaving("pw");
    try {
      await api.post("/me/password", { current_password: pw.current_password, new_password: pw.new_password });
      toast.success("Contraseña actualizada");
      setPw({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving("");
    }
  };

  return (
    <div data-testid="profile-panel">
      <PanelTitle title="Mi perfil" text="Tus datos de cuenta y la wallet donde recibirás el pago de tus comisiones." />
      <div className="mt-6 grid gap-3 sm:grid-cols-3">
        {[["ID", profile.dist_id], ["Nombre", profile.name], ["Celular", profile.phone], ["País", profile.country], ["Patrocinador", profile.sponsor_id || "—"]].map(([k, v]) => (
          <div key={k} className="rounded-2xl border border-ink/10 bg-white p-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.1em] text-ink/60">{k}</p>
            <p className="mt-1 font-semibold" data-testid={`profile-${k.toLowerCase()}`}>{v}</p>
          </div>
        ))}
      </div>

      <form onSubmit={saveWallet} className="mt-8 rounded-[1.5rem] border border-ink/10 bg-white p-6" data-testid="wallet-form">
        <p className="font-display text-xl font-semibold">Wallet para recibir comisiones</p>
        <p className="mt-1 text-sm text-ink/70">Dirección USDC/USDT en la red Polygon. El administrador la usará para pagarte.</p>
        <Input value={wallet} onChange={(e) => setWallet(e.target.value)} placeholder="0x…" className="mt-4 h-11 bg-white font-mono text-xs" data-testid="wallet-input" />
        {walletError && <p className="mt-2 text-sm text-coral" data-testid="wallet-error">{walletError}</p>}
        <button type="submit" disabled={saving === "wallet"} className="btn-ink mt-4 !px-6 !py-3 !text-sm disabled:opacity-60" data-testid="wallet-save">
          {saving === "wallet" ? <Loader2 className="h-4 w-4 animate-spin" /> : "Guardar wallet"}
        </button>
      </form>

      <form onSubmit={savePassword} className="mt-6 rounded-[1.5rem] border border-ink/10 bg-white p-6" data-testid="password-form">
        <p className="font-display text-xl font-semibold">Cambiar contraseña</p>
        <div className="mt-4 grid gap-4 sm:grid-cols-3">
          <Input type="password" required placeholder="Contraseña actual" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="h-11 bg-white" data-testid="password-current" />
          <Input type="password" required minLength={6} placeholder="Nueva contraseña" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="h-11 bg-white" data-testid="password-new" />
          <Input type="password" required minLength={6} placeholder="Confirmar nueva" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} className="h-11 bg-white" data-testid="password-confirm" />
        </div>
        <button type="submit" disabled={saving === "pw"} className="btn-ink mt-4 !px-6 !py-3 !text-sm disabled:opacity-60" data-testid="password-save">
          {saving === "pw" ? <Loader2 className="h-4 w-4 animate-spin" /> : "Actualizar contraseña"}
        </button>
      </form>
    </div>
  );
};
